module.exports = __webpack_public_path__ + "img/daniel.2bcfdd5f.jpg";